/**
 * 定价
 */

import React, { useEffect, useState } from 'react';
import { IProps, IUserInfo, IPlanInfo } from '@umu/umu-types';
import { getAccountPlan } from '@umu/umu-api';
import { VersionItem } from '../@planPricingCommon/components/@pricingVersion/versionItem';
import { PricingTitle } from '../@planPricingCommon/components/@pricingTitle/pricingTitle';
import { PricingPartner } from '../@planPricingCommon/components/@pricingPartner/pricingPartner';

interface IProp {
    siteHost: string;
    userInfo: IUserInfo;
}
export function App(props: IProp) {
    const initStates = {
        userInfo: props.userInfo,
    };
    const [planInfo, setPlanInfo] = useState<IPlanInfo>({} as IPlanInfo);
    useEffect(() => {
        const loadData = async () => {
            const data = await getAccountPlan();
            setPlanInfo(data.data);
        };
        if (!initStates.userInfo.teacher_id || !initStates.userInfo.umu_id) {
            return;
        }
        loadData();
    }, []);
    const planAllInfo: IProps = {
        isRegisterUser: true,
        siteHost: props.siteHost,
        platform: 'mobile',
        planInfo,
    };
    if (!initStates.userInfo.teacher_id || !initStates.userInfo.umu_id) {
        planAllInfo.isRegisterUser = false;
    }
    return (
        <div className="plan-m-pricing-index-page">
            <PricingTitle {...planAllInfo} />
            <VersionItem {...planAllInfo} userInfo={initStates.userInfo} />
            <PricingPartner {...planAllInfo} />
        </div>
    );
}
